module.exports = __webpack_public_path__ + "img/013-watch.976ec502.svg";